function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "error_svg__a",
  d: "M0 359.946h539.1V.296H0z"
}), React.createElement("path", {
  d: "M18.599 11.648a14.971 14.971 0 0 1-9.158 3.109c-3.446 0-6.622-1.16-9.157-3.109V.658h18.315v10.99z",
  id: "error_svg__c"
}), React.createElement("path", {
  id: "error_svg__e",
  d: "M.621 389.603h539.1V29.953H.62z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "matrix(-1 0 0 1 539.72 29.657)"
}, React.createElement("path", {
  d: "M230.827 315.428H7.51a5.36 5.36 0 0 1-5.365-5.356v-145.37a5.36 5.36 0 0 1 5.365-5.356h223.316a5.361 5.361 0 0 1 5.365 5.356v145.37a5.361 5.361 0 0 1-5.365 5.356z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M7.51 159.087h223.316a5.36 5.36 0 0 1 5.365 5.357V289.11H2.146V164.444a5.361 5.361 0 0 1 5.365-5.357",
  fill: "#E6E8ED"
}), React.createElement("path", {
  d: "M214.584 258.673h-86.556a5.361 5.361 0 0 1-5.365-5.356v-71.228a5.36 5.36 0 0 1 5.365-5.356h86.556a5.36 5.36 0 0 1 5.365 5.356v71.228a5.361 5.361 0 0 1-5.365 5.356",
  fill: "#FFF"
}), React.createElement("mask", {
  id: "error_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#error_svg__a"
})), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M2.146 291.254h234.047v-4.285H2.146z"
}), React.createElement("path", {
  d: "M156.482 356.063H88.843c-4.224 0-5.906-5.453-2.415-7.827l7.152-4.862a16.175 16.175 0 0 0 7.087-13.377v-14.57h43.993v14.57a16.174 16.174 0 0 0 7.086 13.377l7.152 4.862c3.492 2.374 1.809 7.827-2.416 7.827",
  fill: "#FFF",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M102.813 317.571v12.427c0 6.069-3 11.732-8.025 15.148l-7.152 4.861c-1.214.826-.953 2.047-.843 2.403.11.354.58 1.511 2.05 1.511h67.64c1.47 0 1.941-1.157 2.05-1.511.11-.356.372-1.577-.842-2.403l-7.152-4.861a18.302 18.302 0 0 1-8.025-15.148V317.57h-39.701zm53.67 40.635h-67.64c-2.886 0-5.301-1.78-6.151-4.535-.851-2.756.142-5.584 2.529-7.206l7.152-4.861a14.026 14.026 0 0 0 6.148-11.606v-16.712h48.285v16.712c0 4.65 2.298 8.988 6.148 11.606l7.152 4.861c2.386 1.622 3.379 4.45 2.529 7.206-.851 2.755-3.265 4.535-6.153 4.535z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M214.584 176.733l-43.278-42.083",
  fill: "#FFF",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M213.086 178.267l-43.277-42.082 2.995-3.07 43.277 42.083z"
}), React.createElement("path", {
  d: "M171.306 134.65l-43.277 42.083",
  fill: "#FFF",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M129.526 178.267l-2.995-3.069 43.277-42.083 2.995 3.07z"
}), React.createElement("path", {
  d: "M219.949 189.323h-97.286v-7.235a5.361 5.361 0 0 1 5.365-5.356h86.556a5.361 5.361 0 0 1 5.365 5.356v7.235z",
  fill: "#C1E1F4",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M194.739 43.964l155.386 102.075 17.093-25.938L211.832 18.026l-17.093 25.938zm156.612 108.01L188.794 45.187l21.812-33.096 162.557 106.785-21.812 33.096z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  fill: "#F7F5F2",
  mask: "url(#error_svg__b)",
  d: "M510.937 254.242L365.26 158.545l19.452-29.517 145.678 95.697z"
}), React.createElement("path", {
  d: "M368.232 157.933l142.093 93.34 17.091-25.937-142.09-93.34-17.094 25.937zm143.318 99.276l-149.263-98.052 21.813-33.096 149.263 98.052-21.813 33.096z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M354.11 159.675a8.669 8.669 0 0 1-2.482-12.019l17.673-26.818c2.639-4.003 8.029-5.113 12.038-2.479 4.01 2.634 5.123 8.015 2.484 12.019l-17.674 26.818c-2.639 4.003-8.028 5.113-12.038 2.479",
  fill: "#F7F5F2",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M376.572 119.075a6.546 6.546 0 0 0-5.478 2.94l-17.673 26.819a6.535 6.535 0 0 0 1.87 9.05 6.502 6.502 0 0 0 4.92.941 6.499 6.499 0 0 0 4.145-2.807L382.03 129.2c1.984-3.01 1.145-7.072-1.87-9.053a6.52 6.52 0 0 0-3.588-1.073m-17.706 44.175c-2.094 0-4.145-.61-5.934-1.786-4.993-3.278-6.381-10.001-3.097-14.985l17.673-26.818a10.762 10.762 0 0 1 6.864-4.65 10.78 10.78 0 0 1 8.148 1.558c4.991 3.28 6.38 10.003 3.096 14.986l-17.674 26.818a10.766 10.766 0 0 1-6.864 4.65 11 11 0 0 1-2.212.227",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M494.598 353.58H299.329c-12.163 0-22.024-9.845-22.024-21.989 0-12.145 9.86-21.99 22.024-21.99h195.269c12.163 0 22.024 9.845 22.024 21.99 0 12.144-9.86 21.989-22.024 21.989",
  fill: "#EFF3F4",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M299.33 311.744c-10.961 0-19.878 8.903-19.878 19.846 0 10.944 8.917 19.848 19.878 19.848h195.268c10.96 0 19.878-8.904 19.878-19.848 0-10.943-8.917-19.846-19.878-19.846H299.33zm195.268 43.979H299.33c-13.328 0-24.17-10.826-24.17-24.133 0-13.306 10.842-24.131 24.17-24.131h195.268c13.328 0 24.17 10.825 24.17 24.131 0 13.307-10.842 24.133-24.17 24.133z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  fill: "#E8E5E2",
  mask: "url(#error_svg__b)",
  d: "M344.631 309.601h104.665v-26.31H344.631z"
}), React.createElement("path", {
  d: "M346.777 307.459H447.15v-22.026H346.777v22.026zm-4.292 4.285h108.957v-30.596H342.485v30.596z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M405.453 283.29H299.76c-2.335 0-4.46-1.19-5.462-3.057l-10.43-19.429c-4.43-8.254-5.25-17.67-2.3-26.427l13.081-38.821c.764-2.27 3.122-3.826 5.797-3.826h98.96c3.34 0 6.048 2.399 6.048 5.356v86.204z",
  fill: "#F7F5F2",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M300.444 193.873c-1.745 0-3.293.972-3.762 2.365l-13.08 38.822c-2.766 8.206-2 16.99 2.155 24.733l10.43 19.43c.63 1.169 2.03 1.925 3.572 1.925h103.548v-84.06c0-1.773-1.751-3.215-3.902-3.215h-98.96zm107.155 91.56h-107.84c-3.15 0-5.967-1.604-7.354-4.187l-10.43-19.43c-4.721-8.795-5.588-18.782-2.441-28.122l13.08-38.821c1.064-3.162 4.211-5.285 7.83-5.285h98.961c4.518 0 8.194 3.365 8.194 7.5v88.345z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M344.483 267.208H306.98a3.68 3.68 0 0 1-3.325-2.098l-6.348-13.333a25.315 25.315 0 0 1-1.399-18.133l7.96-26.64a3.68 3.68 0 0 1 3.529-2.625h38.77a3.678 3.678 0 0 1 3.681 3.675v53.797a5.361 5.361 0 0 1-5.365 5.357M387.228 254.606l-18.396 8.882c-3.562 1.72-7.7-.87-7.7-4.821v-48.931a5.36 5.36 0 0 1 5.365-5.357h21.91c3.147 0 5.62 2.693 5.345 5.824l-3.515 40.048a5.359 5.359 0 0 1-3.009 4.355",
  fill: "#C1E1F4",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M531.588 283.29H405.453v-68.762l126.572 10.31a5.36 5.36 0 0 1 4.928 5.34v47.756a5.361 5.361 0 0 1-5.365 5.356",
  fill: "#F7F5F2",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M407.6 281.148h123.989a3.22 3.22 0 0 0 3.219-3.214v-47.757c0-1.661-1.3-3.068-2.958-3.203L407.6 216.852v64.296zm123.989 4.285H403.307v-73.23l128.892 10.5c3.87.315 6.9 3.598 6.9 7.474v47.757c0 4.134-3.37 7.5-7.51 7.5zM225.029 68.393l-15.866-52.717 4.111-1.234 15.865 52.718z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M191.88 46.715l-.227-4.278 59.578-3.158.227 4.278z"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M263.132 93.375l-13.86-51.4 4.145-1.115 13.859 51.4z"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M227.144 69.918l-.12-4.283 61.762-1.724.12 4.283z"
}), React.createElement("path", {
  d: "M215.525 24.511c0 12.191-9.899 22.074-22.11 22.074-12.21 0-22.109-9.883-22.109-22.074 0-12.19 9.899-22.073 22.11-22.073 12.21 0 22.109 9.882 22.109 22.073",
  fill: "#F7F5F2",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M193.415 4.58c-11.007 0-19.963 8.941-19.963 19.931s8.956 19.931 19.963 19.931c11.008 0 19.964-8.94 19.964-19.93 0-10.991-8.956-19.932-19.964-19.932m0 44.147c-13.374 0-24.255-10.863-24.255-24.216 0-13.352 10.88-24.216 24.255-24.216 13.374 0 24.256 10.864 24.256 24.216 0 13.353-10.882 24.216-24.256 24.216",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M205.646 24.511c0 6.744-5.475 12.212-12.23 12.212-6.755 0-12.232-5.468-12.232-12.212 0-6.743 5.477-12.21 12.231-12.21 6.756 0 12.231 5.467 12.231 12.21",
  fill: "#FFF",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M193.415 14.443c-5.56 0-10.085 4.516-10.085 10.069 0 5.552 4.524 10.069 10.085 10.069 5.56 0 10.085-4.517 10.085-10.07 0-5.552-4.524-10.068-10.085-10.068m0 24.423c-7.927 0-14.377-6.44-14.377-14.354 0-7.915 6.45-14.354 14.377-14.354 7.928 0 14.377 6.44 14.377 14.354 0 7.914-6.45 14.354-14.377 14.354",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M171.306 24.511v110.14",
  fill: "#FFF",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M169.16 134.65h4.292V24.513h-4.292zM300.817 118.135l-14.042-51.52 4.14-1.125 14.043 51.52z"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M265.3 94.958l-.193-4.28 60.275-2.701.193 4.28z"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M340.595 144.338l-17.16-53.567 4.088-1.306 17.161 53.567z"
}), React.createElement("path", {
  fill: "#747991",
  mask: "url(#error_svg__b)",
  d: "M368.204 120.34l-65.337-.625.041-4.285 65.338.625zM482.597 222.7l-111.44-73.1 2.358-3.582 111.44 73.099zM516.343 283.29h4.292v-59.555h-4.292zM503.347 238.571c-.06 0-.117-.002-.177-.007l-85.852-6.993a2.144 2.144 0 0 1-1.964-2.31 2.139 2.139 0 0 1 2.313-1.96l85.852 6.993a2.143 2.143 0 0 1-.172 4.277M490.645 327.105h-186.74a2.144 2.144 0 0 1-2.146-2.143c0-1.182.96-2.142 2.146-2.142h186.74c1.184 0 2.146.96 2.146 2.142a2.145 2.145 0 0 1-2.146 2.143M314.854 303.236h-10.825a2.144 2.144 0 0 0-2.146 2.143v4.222H317v-4.222c0-1.184-.96-2.143-2.146-2.143M271.858 326.188v10.807c0 1.182.96 2.142 2.146 2.142h4.23v-15.092h-4.23a2.144 2.144 0 0 0-2.146 2.143M286.197 306.174l-8.797 6.297a2.14 2.14 0 0 0-.493 2.99l2.465 3.432 12.284-8.794-2.464-3.432a2.148 2.148 0 0 0-2.995-.493M279.371 343.625l12.285 8.794-2.465 3.431a2.149 2.149 0 0 1-2.994.494l-8.797-6.297a2.14 2.14 0 0 1-.493-2.99l2.464-3.432zM522.07 326.188v10.807c0 1.182-.96 2.142-2.146 2.142h-4.23v-15.092h4.23c1.186 0 2.146.959 2.146 2.143M507.731 306.174l8.797 6.297a2.14 2.14 0 0 1 .493 2.99l-2.465 3.432-12.284-8.794 2.464-3.432a2.148 2.148 0 0 1 2.995-.493M514.557 343.625l-12.285 8.794 2.465 3.431a2.149 2.149 0 0 0 2.994.494l8.797-6.297a2.14 2.14 0 0 0 .494-2.99l-2.465-3.432zM344.059 303.236h-10.825a2.144 2.144 0 0 0-2.146 2.143v4.222h15.117v-4.222c0-1.184-.96-2.143-2.146-2.143M373.264 303.236h-10.825a2.144 2.144 0 0 0-2.146 2.143v4.222h15.117v-4.222c0-1.184-.96-2.143-2.146-2.143M402.469 303.236h-10.825a2.144 2.144 0 0 0-2.146 2.143v4.222h15.117v-4.222c0-1.184-.96-2.143-2.146-2.143M431.674 303.236h-10.825a2.144 2.144 0 0 0-2.146 2.143v4.222h15.117v-4.222c0-1.184-.96-2.143-2.146-2.143M460.879 303.236h-10.825a2.144 2.144 0 0 0-2.146 2.143v4.222h15.117v-4.222c0-1.184-.96-2.143-2.146-2.143M490.084 303.236h-10.825a2.144 2.144 0 0 0-2.146 2.143v4.222h15.117v-4.222c0-1.184-.96-2.143-2.146-2.143M317 353.58h-15.117v4.223c0 1.184.962 2.142 2.146 2.142h10.825a2.144 2.144 0 0 0 2.146-2.142v-4.223zM346.205 353.58h-15.117v4.223c0 1.184.962 2.142 2.146 2.142h10.825a2.144 2.144 0 0 0 2.146-2.142v-4.223zM375.41 353.58h-15.117v4.223c0 1.184.962 2.142 2.146 2.142h10.825a2.144 2.144 0 0 0 2.146-2.142v-4.223zM404.615 353.58h-15.117v4.223c0 1.184.962 2.142 2.146 2.142h10.825a2.144 2.144 0 0 0 2.146-2.142v-4.223zM433.82 353.58h-15.117v4.223c0 1.184.962 2.142 2.146 2.142h10.825a2.144 2.144 0 0 0 2.146-2.142v-4.223zM463.025 353.58h-15.117v4.223c0 1.184.962 2.142 2.146 2.142h10.825a2.144 2.144 0 0 0 2.146-2.142v-4.223zM492.23 353.58h-15.117v4.223c0 1.184.962 2.142 2.146 2.142h10.825a2.144 2.144 0 0 0 2.146-2.142v-4.223z"
}), React.createElement("path", {
  d: "M177.39 134.65a6.079 6.079 0 0 1-6.084 6.075 6.08 6.08 0 0 1-6.085-6.075 6.08 6.08 0 0 1 6.085-6.074 6.079 6.079 0 0 1 6.084 6.074",
  fill: "#FFF",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M171.306 130.718a3.939 3.939 0 0 0-3.938 3.932 3.94 3.94 0 0 0 3.938 3.932 3.94 3.94 0 0 0 3.938-3.932 3.939 3.939 0 0 0-3.938-3.932m0 12.15c-4.538 0-8.23-3.687-8.23-8.218 0-4.53 3.692-8.217 8.23-8.217s8.23 3.686 8.23 8.217c0 4.531-3.692 8.217-8.23 8.217M128.028 178.875a3.22 3.22 0 0 0-3.219 3.214v71.228a3.22 3.22 0 0 0 3.22 3.214h86.555a3.22 3.22 0 0 0 3.22-3.214V182.09a3.22 3.22 0 0 0-3.22-3.214h-86.556zm86.556 81.941h-86.556c-4.141 0-7.51-3.365-7.51-7.499V182.09c0-4.135 3.369-7.5 7.51-7.5h86.556c4.141 0 7.511 3.365 7.511 7.5v71.228c0 4.134-3.37 7.5-7.51 7.5z",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M171.465 201.157c-7.1 0-12.876 5.766-12.876 12.855 0 7.088 5.775 12.855 12.876 12.855 7.1 0 12.876-5.767 12.876-12.855 0-7.089-5.776-12.855-12.876-12.855m0 29.995c-9.466 0-17.169-7.69-17.169-17.14s7.703-17.14 17.169-17.14c9.466 0 17.168 7.69 17.168 17.14s-7.702 17.14-17.168 17.14",
  fill: "#747991",
  mask: "url(#error_svg__b)"
}), React.createElement("path", {
  d: "M176.383 208.067a4.914 4.914 0 0 1-4.918 4.91 4.914 4.914 0 0 1-4.919-4.91 4.914 4.914 0 0 1 4.919-4.91 4.914 4.914 0 0 1 4.918 4.91",
  fill: "#747991",
  mask: "url(#error_svg__b)"
})), React.createElement("g", {
  transform: "matrix(-1 0 0 1 377.697 243.91)"
}, React.createElement("mask", {
  id: "error_svg__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#error_svg__c"
})), React.createElement("path", {
  d: "M18.599 9.801c0 5.05-3.411 9.143-8.468 9.143-5.058 0-9.847-4.093-9.847-9.143 0-5.05 4.1-9.143 9.157-9.143 5.058 0 9.158 4.093 9.158 9.143",
  fill: "#747991",
  mask: "url(#error_svg__d)"
})), React.createElement("path", {
  d: "M372.356 269.074h27.162c1.185 0 2.146-.96 2.146-2.143a2.145 2.145 0 0 0-2.146-2.142h-27.162c-1.185 0-2.146.96-2.146 2.142 0 1.183.961 2.143 2.146 2.143zM336.476 277.822h63.042c1.185 0 2.146-.96 2.146-2.143 0-1.182-.96-2.142-2.146-2.142h-63.042c-1.184 0-2.146.96-2.146 2.142 0 1.183.962 2.143 2.146 2.143M336.964 269.074h27.162c1.184 0 2.146-.96 2.146-2.143a2.145 2.145 0 0 0-2.146-2.142h-27.162c-1.185 0-2.146.96-2.146 2.142 0 1.183.961 2.143 2.146 2.143",
  fill: "#CED2DD"
}), React.createElement("path", {
  d: "M247.021 32.042c101.992 92.135 189.74 33.047 263.12 98.413 73.38 65.365-85.504 225.051-185.603 269.331-100.099 44.28-256.31 49.037-303.78-147.071-47.47-196.108 124.27-312.809 226.263-220.673z",
  fillOpacity: 0.1,
  fill: "#A5C6E0"
}), React.createElement("path", {
  fill: "#747991",
  d: "M417.058 221.122h-97.286v-4.285h97.286z"
}), React.createElement("path", {
  d: "M532.21 191.145a3.22 3.22 0 0 1 3.218 3.214v145.37a3.22 3.22 0 0 1-3.219 3.214H308.893a3.22 3.22 0 0 1-3.22-3.214v-145.37a3.22 3.22 0 0 1 3.22-3.214h223.316zM308.892 347.228h223.316c4.142 0 7.511-3.364 7.511-7.5V194.36c0-4.135-3.369-7.499-7.51-7.499H308.892c-4.14 0-7.511 3.364-7.511 7.5v145.369c0 4.135 3.37 7.499 7.51 7.499z",
  fill: "#747991"
}), React.createElement("path", {
  d: "M197.08 295.828h-2.938a4.265 4.265 0 0 1-4.27-4.262v-53.268a4.266 4.266 0 0 1 4.27-4.263h2.939v61.793z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M232.323 236.178c.674 0 1.278.451 1.473 1.095l7.96 26.64a23.144 23.144 0 0 1-1.281 16.602l-6.348 13.333a1.543 1.543 0 0 1-1.386.874h-37.504a3.22 3.22 0 0 1-3.219-3.214v-53.797c0-.845.69-1.533 1.536-1.533h38.77zm-37.086 62.829h37.504a5.856 5.856 0 0 0 5.263-3.32l6.348-13.333a27.43 27.43 0 0 0 1.517-19.667l-7.96-26.638a5.866 5.866 0 0 0-5.586-4.156h-38.77c-3.212 0-5.827 2.61-5.827 5.818v53.797c0 4.135 3.37 7.499 7.511 7.499z",
  fill: "#747991"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M156.614 284.885l-5.945-1.714-4.729-46.993 5.525-1.06z"
}), React.createElement("path", {
  d: "M173.224 236.178a3.22 3.22 0 0 1 3.22 3.214v48.932c0 1.13-.551 2.121-1.508 2.722a3.165 3.165 0 0 1-3.114.17l-18.394-8.882a3.23 3.23 0 0 1-1.806-2.613l-3.515-40.048a3.177 3.177 0 0 1 .833-2.451 3.186 3.186 0 0 1 2.374-1.044h21.91zm.005 59.65a7.507 7.507 0 0 0 3.987-1.152 7.454 7.454 0 0 0 3.52-6.352v-48.932c0-4.134-3.37-7.499-7.512-7.499h-21.91c-2.101 0-4.12.887-5.538 2.433a7.513 7.513 0 0 0-1.945 5.72l3.516 40.049a7.536 7.536 0 0 0 4.211 6.097l18.395 8.883a7.551 7.551 0 0 0 3.276.754z",
  fill: "#747991"
}));

var SvgError = function SvgError(props) {
  return React.createElement("svg", _extends({
    width: 540,
    height: 425
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/error.466ad54c.svg";
export { SvgError as ReactComponent };